import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../Component/axiosInstance";

const addNearestInfra = createAsyncThunk(
  "nearestInfra",
  async ({ nearest_infrastructure , projectiondataID }, {rejectWithValue}) => {
    try {
      const response = await axiosInstance.post('/project/addNearestLocation', { nearest_infrastructure } , 
        {
            headers:{
                'x-project-id' :projectiondataID
            }
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Some Error Occurred");
    }
  }
);

const addNearestInfraSlice = createSlice({
  name: "addNearestInfra",
  initialState: {
    loading: false,
    error: null,
    data: null,
    isSuccess: false,
    isError: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addNearestInfra.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.data = null;
        state.isSuccess = false;
        state.isError = false;
      })
      .addCase(addNearestInfra.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.isSuccess = true;
        state.isError = false;
      })
      .addCase(addNearestInfra.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
        state.data = null;
        state.isError = true;
        state.isSuccess = false;
      });
  }
});

export { addNearestInfra };
export default addNearestInfraSlice.reducer;
